import { useIsMobile } from '@/hooks/use-is-mobile';
import clsx from 'clsx';
import Link from 'next/link';

const SignTip = props => {
  const { className } = props;
  const { isMobile } = useIsMobile();

  return (
    <div
      className={clsx(
        'absolute left-0 top-0 z-[1] hidden h-full w-full overflow-hidden bg-primary pt-[120px] ',
        className,
      )}
    >
      <Link
        className={clsx(
          'mx-7 block  rounded-[10px] bg-white text-center font-poppins text-base font-[600] leading-[54px] text-primary',
        )}
        href={isMobile ? '/create-account' : '/sign-in'}
      >
        SIGN UP
      </Link>

      <div className={clsx(' mt-5 text-center font-sans text-base text-white')}>
        <span>Already A Member?</span>
        <Link
          href='/sign-in'
          className='mx-1 underline'
        >
          Log In
        </Link>
      </div>
    </div>
  );
};

export default SignTip;
